import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const Logout = Loadable(lazy(() => import("./Logout.jsx")));

const LogoutRoutes = [
    { path: "/session/logout", element: <Logout/> },
];

export default LogoutRoutes;